(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dg-pot-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-pot-fit')) {
  customElements.define('dg-pot-fit', class extends HTMLElement {
    connectedCallback() {
      if(this.fitMoving)return;
      this.fitCleanup?.();
      const version = this.fitVersion = (this.fitVersion || 0) + 1;
      initializeFit(this, version).catch(() => { this.hidden = true; });
    }
    disconnectedCallback() {
      if(this.fitMoving)return;
      this.fitVersion = (this.fitVersion || 0) + 1;
      this.fitCleanup?.();
    }
  });
}

async function initializeFit(host, version) {
  await customElements.whenDefined('upsell-widget');
  if (!host.isConnected || host.fitVersion !== version || host.dataset.productId !== '10447716581676' || host.dataset.variantId !== '53427782910252') return;
  const root = host.closest('product-info');
  const choice = root?.querySelector('.product__upsell [data-upsell-add="53427782910252"]') || host.querySelector('[data-fit-fallback] [data-upsell-add]');
  const hero = root?.querySelector('.product-media-container.media-type-image');
  const original = hero?.querySelector('modal-opener');
  if (!choice || choice.disabled || !hero || !original) return;
  const quick = host.querySelector('[data-fit-add]');
  const preview = host.querySelector('[data-fit-preview]');
  const controls = host.querySelector('[data-fit-controls]');
  const status = host.querySelector('[data-fit-status]');
  const imageOpen = host.querySelector('[data-fit-image-open]');
  const imageDialog = host.querySelector('[data-fit-image-template]').content.firstElementChild.cloneNode(true);
  const fullImage = imageDialog.querySelector('[data-fit-full-image]');
  const imageStatus = imageDialog.querySelector('[data-fit-image-status]');
  document.body.append(imageDialog);
  const scene = host.querySelector('[data-fit-template]').content.firstElementChild.cloneNode(true);
  const originalVisibility = original.style.visibility;
  const originalInert = original.inert;
  hero.append(scene);
  hero.classList.add('dg-fit-hero');
  const nodes = Object.fromEntries(['plant-sprite','plant-leaves','pot-back','pot-front','plant-shadow','pot-shadow','landing-ring','nursery-note','fit-mark'].map(name=>[name,scene.querySelector('.'+name)]));
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const state = {hasPot:host.dataset.inCart==='true',playing:false,previewed:false,previewBusy:false,ready:false,preparing:null,frame:0,run:0,feedback:0,busy:false,destroyed:false,reduced:media.matches};
  const copy = Object.fromEntries(['add','preview','previewLoading','previewDone','previewFailed','imageLoading','imageFailed','inCart','replay','adding','added','failed','lift','enter','lower','done'].map(key=>[key,host.dataset['copy'+key[0].toUpperCase()+key.slice(1)]]));
  const clamp=(x,a=0,b=1)=>Math.min(b,Math.max(a,x));
  const lerp=(a,b,t)=>a+(b-a)*t;
  const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
  const out=t=>1-Math.pow(1-t,3);
  const step=(t,a,b,fn=ease)=>fn(clamp((t-a)/(b-a)));
  const announce=(text,error=false)=>{status.textContent=text;status.classList.toggle('visually-hidden',!error);};
  const active=()=>!state.destroyed&&host.isConnected;
  const listeners=[];
  function listen(target,name,callback){target.addEventListener(name,callback);listeners.push(()=>target.removeEventListener(name,callback));}
  function update(){
    quick.disabled=state.busy||state.hasPot;
    quick.setAttribute('aria-busy',String(state.busy));
    host.querySelector('[data-fit-label]').textContent=state.busy?copy.adding:state.hasPot?copy.inCart:copy.add;
    preview.disabled=state.previewBusy||state.busy;
    preview.setAttribute('aria-busy',String(state.previewBusy));
    host.querySelector('[data-fit-preview-label]').textContent=state.previewBusy?copy.previewLoading:state.previewed?copy.replay:copy.preview;
    controls.hidden=!state.previewed&&!state.hasPot;
    host.querySelector('[data-fit-photo]').hidden=!state.previewed;
    host.querySelector('[data-fit-combination]').hidden=!state.previewed;
    host.querySelector('[data-fit-cart]').hidden=!state.hasPot;
    host.dataset.fitReady=String(state.ready);
    host.dataset.fitPlaying=String(state.playing);
    host.dataset.fitSelected=String(state.hasPot);
  }
  function resize(){const r=hero.getBoundingClientRect();scene.style.setProperty('--scene-scale',String(Math.max(.1,Math.min(r.width/600,(r.height-36)/540))));}
  function showScene(show){
    scene.hidden=!show;original.style.visibility=show?'hidden':originalVisibility;original.inert=show?true:originalInert;
    if(show)state.previewed=true;
    host.querySelector('[data-fit-photo]').setAttribute('aria-pressed',String(!show));
    host.querySelector('[data-fit-combination]').setAttribute('aria-pressed',String(show));
    if(show)resize();
    update();
  }
  function cancel(){cancelAnimationFrame(state.frame);state.run++;state.playing=false;update();}
  function cancelPreview(){state.feedback++;state.previewBusy=false;cancel();}
  function finalPose(){paint({y:19},{a:1},{done:1,shadow:0});scene.querySelector('.scene-state').textContent=copy.done;}

  async function texture(source, leaves=false) {
    const img = new Image();
    img.crossOrigin='anonymous';img.src=source;
    let timeout;try{await Promise.race([img.decode(),new Promise((_,reject)=>{timeout=setTimeout(()=>reject(new Error('Image loading timed out')),6500);})]);}finally{clearTimeout(timeout);}
    const canvas=document.createElement('canvas');
    canvas.width=img.naturalWidth;canvas.height=img.naturalHeight;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});
    ctx.drawImage(img,0,0);
    const pixels=ctx.getImageData(0,0,canvas.width,canvas.height);
    const d=pixels.data;
    let x0=canvas.width,y0=canvas.height,x1=0,y1=0;
    for(let y=0;y<canvas.height;y++)for(let x=0;x<canvas.width;x++){
      const i=(y*canvas.width+x)*4;
      const r=d[i],g=d[i+1],b=d[i+2];
      const lo=Math.min(r,g,b),hi=Math.max(r,g,b),sat=hi-lo;
      if(lo>213&&sat<17)d[i+3]=0;
      else if(lo>205&&sat<23)d[i+3]=Math.round(d[i+3]*clamp((sat-10)/13));
      if(d[i+3]>20){x0=Math.min(x,x0);x1=Math.max(x,x1);y0=Math.min(y,y0);y1=Math.max(y,y1);}
      if(leaves&&!(g>r*1.015&&g>b*1.055))d[i+3]=0;
    }
    if(x1<=x0||y1<=y0)throw new Error('The product layer is empty');
    ctx.putImageData(pixels,0,0);
    const cut=document.createElement('canvas');
    cut.width=x1-x0+1;cut.height=y1-y0+1;
    cut.getContext('2d').drawImage(canvas,x0,y0,cut.width,cut.height,0,0,cut.width,cut.height);
    return {url:cut.toDataURL('image/png'),width:cut.width,height:cut.height};
  }


  function paint(plant,pot,extra={}){
    const transform=`translate3d(${plant.x||0}px,${plant.y||0}px,0) rotate(${plant.r||0}deg) scale(${plant.s||1})`;
    nodes['plant-sprite'].style.transform=transform;
    nodes['plant-leaves'].style.transform=transform;
    for(const n of ['pot-back','pot-front']){
      nodes[n].style.transform=`translate3d(${pot.x||0}px,${pot.y||0}px,0) rotate(${pot.r||0}deg)`;
      nodes[n].style.opacity=pot.a??0;
    }
    nodes['plant-shadow'].style.opacity=extra.shadow??1;
    nodes['plant-shadow'].style.transform=`translateX(-50%) scale(${extra.shadowScale??1})`;
    nodes['pot-shadow'].style.opacity=pot.a??0;
    nodes['pot-shadow'].style.transform=`translateX(calc(-50% + ${pot.x||0}px))`;
    nodes['nursery-note'].style.opacity=extra.note??0;
    nodes['fit-mark'].style.opacity=extra.done??0;
    nodes['landing-ring'].style.opacity=extra.ring??0;
    nodes['landing-ring'].style.transform=`scale(${extra.ringScale??1})`;
  }


  function renderFrame(t,mode){
    const lift=step(t,0,.27,out);
    const lower=step(t,.5,.89,ease);
    const enter=step(t,.21,.49,out);
    let x=0,y=lerp(-104,19,lower)*lift,r=0,s=1-.105*lift*(1-lower);
    let px=lerp(195,0,enter),py=0,pr=0;
    if(mode==='arc'){
      x=-52*Math.sin(Math.PI*step(t,0,.9));
      y=lerp(-116,19,lower)*lift;
      r=-5.5*Math.sin(Math.PI*step(t,0,.9));
      px=lerp(180,0,enter);py=-18*Math.sin(Math.PI*enter);pr=5*(1-enter);
    }
    if(mode==='click'){
      px=lerp(135,0,enter);pr=-3*Math.sin(Math.PI*enter);
      if(t>.86){const q=clamp((t-.86)/.14);y=19-5*Math.sin(q*Math.PI)*Math.exp(-q*1.5);}
    }else if(t>.89){const q=(t-.89)/.11;r+=Math.sin(q*Math.PI*2)*.9*(1-q);}
    const settle=step(t,.87,1,out);
    const note=step(t,.12,.26)* (1-step(t,.56,.72));
    const ringT=clamp((t-.86)/.14);
    paint({x,y,r,s},{x:px,y:py,r:pr,a:step(t,.18,.3)}, {
      note,done:settle,shadow:1-lift*.88,shadowScale:1-lift*.35,
      ring:mode==='click'&&t>.86?(1-ringT)*.55:0,ringScale:1+ringT*.28
    });
    const caption=t<.27?copy.lift:t<.54?copy.enter:t<.9?copy.lower:copy.done;
    if(scene.querySelector('.scene-state').textContent!==caption)scene.querySelector('.scene-state').textContent=caption;
  }



  function prepare(){
    if(state.ready)return Promise.resolve();
    if(state.preparing)return state.preparing;
    state.preparing=Promise.all([texture(host.dataset.plantImage),texture(host.dataset.potImage),texture(host.dataset.plantImage,true)]).then(([plant,pot,leaves])=>{
      if(!active())return;
      const plantWidth=342,potWidth=160,plantHeight=plantWidth*plant.height/plant.width,potHeight=potWidth*pot.height/pot.width;
      for(const key of ['plant-sprite','plant-leaves']){
        nodes[key].style.width=plantWidth+'px';nodes[key].style.left=(300-plantWidth/2)+'px';nodes[key].style.top=(473-plantHeight)+'px';
        nodes[key].querySelector('img').src=key==='plant-leaves'?leaves.url:plant.url;
      }
      for(const key of ['pot-back','pot-front']){
        nodes[key].style.width=potWidth+'px';nodes[key].style.left=(300-potWidth/2)+'px';nodes[key].style.top=(500-potHeight)+'px';nodes[key].querySelector('img').src=pot.url;
      }
      state.ready=true;update();
    }).catch(error=>{state.preparing=null;throw error;});
    return state.preparing;
  }

  function play(){
    if(!active()||!state.ready)return;
    cancel();showScene(true);
    const rect=hero.getBoundingClientRect();
    const header=root.ownerDocument.querySelector('.section-header');
    const safeTop=Math.min(110,Math.max(24,header?.getBoundingClientRect().bottom||24));
    const outside=rect.top<safeTop||rect.bottom>innerHeight;
    const top=Math.max(0,scrollY+rect.top-Math.max(safeTop,(innerHeight-rect.height)/2));
    if(state.reduced){finalPose();if(outside)window.scrollTo({top,behavior:'instant'});announce(copy.previewDone);return;}
    if(outside)window.scrollTo({top,behavior:'smooth'});
    state.playing=true;update();
    const run=state.run,start=performance.now()+(outside?550:120);
    announce(copy.previewDone);
    function tick(now){
      if(run!==state.run||!active())return;
      const t=clamp((now-start)/1800);renderFrame(t,'click');
      if(t<1)state.frame=requestAnimationFrame(tick);
      else{state.playing=false;update();finalPose();}
    }
    state.frame=requestAnimationFrame(tick);
  }

  listen(imageOpen,'click',()=>{
    cancelPreview();if(state.ready&&!scene.hidden)finalPose();
    if(!fullImage.complete||!fullImage.naturalWidth){
      imageStatus.textContent=copy.imageLoading;imageStatus.hidden=false;
      fullImage.src=fullImage.dataset.src;
    }
    imageDialog.showModal();
  });
  listen(fullImage,'load',()=>{imageStatus.hidden=true;});
  listen(fullImage,'error',()=>{imageStatus.textContent=copy.imageFailed;imageStatus.hidden=false;});
  listen(imageDialog.querySelector('[data-fit-image-close]'),'click',()=>imageDialog.close());
  listen(imageDialog,'click',event=>{
    if(event.target!==imageDialog)return;
    const rect=imageDialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)imageDialog.close();
  });

  function openCart(){
    cancelPreview();if(!scene.hidden)finalPose();
    const drawer=document.querySelector('cart-drawer');
    if(drawer?.open)drawer.open(host.querySelector('[data-fit-cart]'));
    else window.location.assign(window.routes?.cart_url||'/cart');
  }
  async function replay(){
    if(state.previewBusy||state.busy)return;
    const feedback=++state.feedback;
    const current=()=>active()&&feedback===state.feedback;
    state.previewBusy=true;announce(copy.previewLoading);update();
    try{await prepare();if(current())play();}
    catch{if(current())announce(copy.previewFailed,true);}
    finally{if(current()){state.previewBusy=false;update();}}
  }

  listen(preview,'click',replay);
  listen(quick,'click',()=>{
    if(state.busy||state.hasPot)return;
    if(!choice.isConnected||choice.disabled)return;
    if(choice.classList.contains('is-loading'))return;
    cancelPreview();
    if(state.ready&&!scene.hidden)finalPose();
    state.busy=true;announce(copy.adding);update();choice.click();
  });
  listen(root,'deco:upsell-added',event=>{
    if(event.detail?.variantId!=='53427782910252'||event.detail.button!==choice)return;
    state.hasPot=true;
    state.busy=false;cancelPreview();
    if(state.ready&&!scene.hidden)finalPose();
    announce(copy.added);update();
    document.querySelector('cart-drawer')?.setActiveElement?.(preview);
  });
  let wasLoading=choice.classList.contains('is-loading');
  const choiceObserver=new MutationObserver(()=>{
    const loading=choice.classList.contains('is-loading');
    if(loading){state.busy=true;update();}
    else if(wasLoading&&!choice.classList.contains('is-added')){state.busy=false;update();announce(copy.failed,true);}
    wasLoading=loading;
  });
  choiceObserver.observe(choice,{attributes:true,attributeFilter:['class']});
  listen(host.querySelector('[data-fit-photo]'),'click',()=>{cancelPreview();showScene(false);});
  listen(host.querySelector('[data-fit-combination]'),'click',()=>{if(state.ready){cancelPreview();finalPose();showScene(true);}else replay();});
  listen(host.querySelector('[data-fit-cart]'),'click',openCart);
  listen(media,'change',event=>{state.reduced=event.matches;cancel();if(state.ready&&!scene.hidden)finalPose();});
  listen(document,'visibilitychange',()=>{if(document.hidden&&state.playing){cancel();finalPose();}});
  const resizeObserver=new ResizeObserver(resize);resizeObserver.observe(hero);
  const preloadObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){preloadObserver.disconnect();prepare().catch(()=>{});}},{rootMargin:'240px'});
  preloadObserver.observe(host);
  const layout=matchMedia('(max-width: 749px)');
  const desktopAnchor=document.createComment('dg-fit-desktop');
  host.before(desktopAnchor);
  const purchaseForm=root.querySelector('.product-form__submit')?.closest('product-form');
  const mobileAnchor=purchaseForm?document.createComment('dg-fit-mobile'):null;
  if(mobileAnchor)purchaseForm.after(mobileAnchor);
  function positionControl(){
    const anchor=layout.matches&&mobileAnchor?mobileAnchor:desktopAnchor;
    if(anchor.nextSibling===host)return;
    host.fitMoving=true;
    try{anchor.after(host);}finally{host.fitMoving=false;}
  }
  listen(layout,'change',positionControl);
  let unsubscribe;
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{
      if(event.source!=='cart-items'||!Array.isArray(event.cartData?.items))return;
      state.hasPot=event.cartData.items.some(item=>String(item.variant_id||item.id)==='53427782910252'&&item.quantity>0);
      if(!state.hasPot){state.busy=false;state.previewed=false;cancelPreview();showScene(false);}
      update();
    });
  }
  host.fitCleanup=()=>{state.destroyed=true;cancelAnimationFrame(state.frame);state.feedback++;listeners.forEach(remove=>remove());choiceObserver.disconnect();resizeObserver.disconnect();preloadObserver.disconnect();unsubscribe?.();original.style.visibility=originalVisibility;original.inert=originalInert;hero.classList.remove('dg-fit-hero');scene.remove();imageDialog.close();imageDialog.remove();desktopAnchor.remove();mobileAnchor?.remove();};
  positionControl();
  host.hidden=false;update();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('pot-media-gallery')) return;

    class PotMediaGallery extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;
        this.gallery = this.querySelector('media-gallery');
        this.productInfo = this.closest('product-info');
        this.applyColor(this.dataset.initialColor);

        if (this.productInfo) {
          this.variantControlChangeHandler = (event) => {
            const control = event.target;
            if (
              !control ||
              typeof control.matches !== 'function' ||
              !control.matches('input[type="radio"], select') ||
              typeof control.closest !== 'function' ||
              !control.closest('variant-selects')
            ) return;

            const color = this.resolveColor(control.value);
            if (color) this.applyColor(color);
          };
          this.productInfo.addEventListener('change', this.variantControlChangeHandler);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event?.data?.variant;
            if (!variant) return;
            const variantProductId = variant.product_id || variant.productId;
            if (variantProductId && String(variantProductId) !== this.dataset.productId) return;
            this.applyColor(variant.options);
          });
        }
      }

      disconnectedCallback() {
        if (typeof this.variantUnsubscriber === 'function') this.variantUnsubscriber();
        if (this.productInfo && this.variantControlChangeHandler) {
          this.productInfo.removeEventListener('change', this.variantControlChangeHandler);
        }
      }

      resolveColor(options) {
        const value = String(options || '').toLowerCase();
        if (value.includes('אפור') || value.includes('grey') || value.includes('gray')) return 'grey';
        if (value.includes('לבן') || value.includes('white')) return 'white';
        if (value.includes('חרדל') || value.includes('mustard')) return 'mustard';
        if (value.includes('שמנת') || value.includes('cream')) return 'cream';
        return '';
      }

      applyColor(options) {
        const color = this.resolveColor(options) || this.dataset.initialColor || 'cream';
        this.dataset.activeColor = color;

        const mediaItems = Array.from(this.querySelectorAll('[data-pot-media-color]'));
        const versionRank = (version) => Number(String(version || 'v1').replace(/\D/g, '')) || 1;
        const latestHomeVersionByKey = new Map();
        mediaItems.forEach((item) => {
          if (item.dataset.potMediaScene !== 'home' || !item.dataset.potMediaPlant) return;
          const mediaKey = `${item.dataset.potMediaColor}:${item.dataset.potMediaPlant}`;
          const rank = versionRank(item.dataset.potMediaVersion);
          latestHomeVersionByKey.set(mediaKey, Math.max(latestHomeVersionByKey.get(mediaKey) || 1, rank));
        });

        mediaItems.forEach((item) => {
          const mediaKey = `${item.dataset.potMediaColor}:${item.dataset.potMediaPlant}`;
          const isReplacedHome = Boolean(
            item.dataset.potMediaScene === 'home' &&
            item.dataset.potMediaPlant &&
            versionRank(item.dataset.potMediaVersion) < (latestHomeVersionByKey.get(mediaKey) || 1)
          );
          item.hidden = item.dataset.potMediaColor !== color || isReplacedHome;
        });

        const viewer = this.gallery?.querySelector('[id^="GalleryViewer"]');
        const thumbnails = this.gallery?.querySelector('[id^="GalleryThumbnails"]');
        const visibleMedia = Array.from(
          viewer?.querySelectorAll('[data-pot-media-color]:not([hidden])') || [],
        );
        const visibleThumbnails = Array.from(
          thumbnails?.querySelectorAll('[data-pot-media-color]:not([hidden])') || [],
        );
        const firstMedia = visibleMedia.find((item) => item.dataset.potMediaScene === 'empty') || visibleMedia[0];

        visibleMedia.forEach((item) => item.classList.remove('is-active'));
        if (firstMedia) firstMedia.classList.add('is-active');

        visibleThumbnails.forEach((item, index) => {
          item.dataset.mediaPosition = String(index + 1);
          item.querySelector('button')?.removeAttribute('aria-current');
        });
        const firstThumbnail = firstMedia
          ? visibleThumbnails.find((item) => item.dataset.target === firstMedia.dataset.mediaId)
          : null;
        firstThumbnail?.querySelector('button')?.setAttribute('aria-current', 'true');

        const controls = this.gallery?.querySelector('[data-pot-slider-buttons]');
        if (controls) controls.hidden = visibleMedia.length <= 1;
        const currentCounter = controls?.querySelector('.slider-counter--current');
        const totalCounter = controls?.querySelector('.slider-counter--total');
        if (currentCounter) currentCounter.textContent = firstMedia ? '1' : '0';
        if (totalCounter) totalCounter.textContent = String(visibleMedia.length);

        window.requestAnimationFrame(() => {
          viewer?.resetPages?.();
          thumbnails?.resetPages?.();
          if (firstMedia && typeof this.gallery?.setActiveMedia === 'function') {
            this.gallery.setActiveMedia(firstMedia.dataset.mediaId, false);
          }
        });
      }
    }

    customElements.define('pot-media-gallery', PotMediaGallery);
  })();
  } catch(e) { console.error(e); }
})();

})();
